const title = {
  fontSize: '26px',
  lineHeight: '32.5px',
  fontWeight: '700',
  textTransform: 'none',
  'screen-medium': {
    fontSize: '34px',
    lineHeight: '42.5px',
  }
}

const loyaltyProductsGrid = {
  title
}

export default loyaltyProductsGrid
